__turbopack_context__.v({
  "wrapper": "PhoneInput-module__HV8Tza__wrapper",
});
